<template>


  <div>
    <div v-bind:class="{'beer-fill' : drink.label.toLowerCase().indexOf('bier') > 0 && fillingAnimation,
                        'wine-fill' : drink.label.toLowerCase().indexOf('wein') >= 0 && fillingAnimation,
                        'default-fill' : isOtherDrink(drink) && fillingAnimation}">
      <counter :config="{min:0, max:99, start:drink.quantity, stepSize: 1}"
               @decremented="handleChangeDecremented"
               @incremented="handleChangeIncremented"
               @below-minimum-attempt="$emit('below-minimum-attempt')">
        <template v-slot:after-value>
          <img style="height:40px" class="mx-2 inline-block" :src="require('@/assets/' + drink.icon)">
        </template>

        <template v-slot:sublabel>
          {{ drink.label }} ({{ drink.size }}{{ drink.unit }}) {{ drink.vol }}% Alk.
        </template>
      </counter>
    </div>

  </div>
</template>

<script>

import counter from "./counter";

export default {
  name: "drink",
  props: {
    drink: {
      required: true
    }
  },
  data() {
    return {
      fillingAnimation: false,
    }
  },
  methods: {

    isOtherDrink(drink) {
        return (drink.label.toLowerCase().indexOf('bier') < 0 && drink.label.toLowerCase().indexOf('wein') < 0);
    },

    handleChangeDecremented(value) {
      this.fillingAnimation = false;
      this.$emit('changed', value)
    },

    handleChangeIncremented(value) {

      this.$emit('changed', value)

      if (this.fillingAnimation)
        return;

      this.fillingAnimation = true;
      setTimeout(() => {
        this.fillingAnimation = false;
      }, 2000)
    }
  },
  components: {
    counter
  }
}
</script>

<style scoped>

.wave {

}

.beer-fill {
  width: 100%;
  z-index: 12;
  background-size: contain;
  background-repeat: repeat-x !important;
  animation: wave-animation1 2.0s infinite linear;
  background: url('~@/assets/beer_fill.png');
}

.wine-fill {
  width: 100%;
  z-index: 12;
  background-size: contain;
  background-repeat: repeat-x !important;
  animation: wave-animation1 2.0s infinite linear;
  background: url('~@/assets/wine_fill.png');
  height:100%;
}

.default-fill {
  width: 100%;
  z-index: 12;
  background-size: contain;
  background-repeat: repeat-x !important;
  animation: wave-animation1 2.0s infinite linear;
  background: url('~@/assets/default_fill.png');
}

@keyframes wave-animation1 {
  0% {
    background-position: 0px 50px;
  }

  100% {
    background-position: 0px -25px;
  }
}

.wave1 {

}

.wave2 {
  background: url('http://www.templates-preview.com/bootstrap-templates/300111854/images/wave2.png');
}
</style>